import type { SpreadsheetRange, StoryModel } from 'types/story';
import type { UserFeatureFlags } from 'types/user';
import { SET_STORY } from 'client/constants/actions';

export type SetStoryPayload = {
	story: StoryModel;
	spreadsheetVariables?: SpreadsheetRange[];
	features?: UserFeatureFlags;
};

export function setStory(payload: SetStoryPayload) {
	return {
		type: SET_STORY,
		payload,
	};
}
